import { Input, Select } from "@/components/shared/form";
import { useTranslations } from "next-intl";

interface AdditionalPartnerProps {
  companyName: string;
  salutation: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

const AdditionalPartner = ({ ...props }: AdditionalPartnerProps) => {
  const t = useTranslations("common");

  return (
    <div className="mt-3 flex flex-col gap-3">
      <div className="flex flex-col items-center gap-3 sm:flex-row">
        <Input name={props.companyName} label={t("company")} />
        <Select
          name={props.salutation}
          label={`${t("salutation")}*`}
          placeholder={t("pleaseSelect")}
          selectItem={
            [
              { label: t("mr"), value: "mr" },
              { label: t("mrs"), value: "mrs" },
              { label: t("divers"), value: "divers" },
              { label: t("noneSalutation"), value: "noneSalutation" },
            ] as const
          }
        />
      </div>
      <div className="flex flex-col items-center gap-3 sm:flex-row">
        <Input name={props.firstName} label={`${t("firstName")}*`} />
        <Input name={props.lastName} label={`${t("lastName")}*`} />
      </div>
      <div className="flex flex-col items-center gap-3 sm:flex-row">
        <Input name={props.email} label={`${t("email")}*`} />
        <Input name={props.phone} label={`${t("phone")}*`} />
      </div>
    </div>
  );
};

export default AdditionalPartner;
